import { z } from 'zod'

// A helper function to generate default values based on Zod's field types
function defaultValueForZodType(zodType: z.ZodTypeAny): any {
  if (zodType instanceof z.ZodString) {
    return ''
  } else if (zodType instanceof z.ZodNumber) {
    return 0
  } else if (zodType instanceof z.ZodBoolean) {
    return false
  } else if (zodType instanceof z.ZodOptional) {
    return undefined
  } else if (zodType instanceof z.ZodEffects) {
    return ''
  }

  throw new Error(`Unsupported Zod type: ${zodType.constructor.name}`)
}

// Function to generate an object from a Zod schema
export function generateObjectFromSchema<T extends z.ZodObject<any>>(schema: T): z.infer<T> {
  const shape = schema.shape
  const generatedObject: any = {}

  for (const key in shape) {
    const fieldType = shape[key]
    const defaultValue = defaultValueForZodType(fieldType)
    if (defaultValue !== undefined) {
      generatedObject[key] = defaultValue
    }
  }

  return generatedObject
}

// Zod by default returns error messages in English.
export const zodCustomErrorMapSettings: z.ZodErrorMap = (issue, ctx) => {
  if (ctx.defaultError === 'Required') {
    return { message: 'forms.global.error.required' }
  }

  return { message: '' }
}
